import RowAction from "application/components/RowAction";
import { taskManagementSystem } from "globals/configuration/taskManagementSystem";
import formControl from "globals/form-control";
import RowColorCell from "application/components/RowColorCell";
import { useMaterialUIController } from "context";
import { setAssignTo } from "context";
import DefaultCell from "application/components/DefaultCell";

import CTLUnReadCell from "application/components/CTLUnReadCell";
import ChangeDateCell from "../../changeDateCell";

const Attributes = {
  formSize: "lg",
  enableAddButton: false,
  enableRefresh: true,
  enableUpdateTableRecords: false,
  enableDownloadButton: false,
  enableDownloadPdf: false,
  settingsMode: false,
  enableAdvanceSearch: true,
  modes: taskManagementSystem.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
    };
  }),
};

const operationURLS = {
  create: "task/create",
  update: "task/update",
  delete: "task/delete",
};

const getColumns = () => {
  const [controller, dispatch] = useMaterialUIController();
  const { assignTo } = controller;

  const onChangeAssign = (event) => {
    let isChecked = event.target.value;

    if (isChecked === 1 || isChecked === 2) {
      setAssignTo(dispatch, isChecked);
    } else {
      setAssignTo(dispatch, "");
    }
  };
  return [
    {
      Header: "Ticket Id",
      accessor: "id",
      displayInList: true,
      dataType: "integer",
      width: 6,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Status Indicator",
      accessor: "",
      displayInList: true,
      width: 6,
      sortDisable: true,
      Cell: ({ value, row }) => <RowColorCell value={value} row={row} />,
    },
    {
      Header: "Task Source",
      accessor: "taskSource",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Customer Name",
      accessor: "name",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Customer No",
      accessor: "contactNo",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      validation: formControl.string().digitsOnly().nullable(),
      width: 6,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Task Subject",
      accessor: "tasksName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      validation: formControl.string().required("Required").nullable(),
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Due date",
      accessor: "expectedCompletionDate",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      isEndTime: true,
      controlType: "dateTime",
      width: 6,

      validation: formControl.string().required("Required").nullable(),
      Cell: ({ value, row }) => <ChangeDateCell value={value} row={row} />,
    },
    {
      Header: "Task Complete Date",
      accessor: "taskCompletedOn",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      controlType: "futureDateTime",
      width: 6,

      validation: formControl.string().required("Required").nullable(),
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Priority",
      accessor: "taskPriority",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      width: 6,
      controlType: "select",
      filterControlType: "select",
      options: {
        keyField: "taskPriority",
        keyDescription: "taskPriority",
        values: [],
        url: "/taskPriority/listAll",
      },

      validation: formControl.string().required("Required").nullable(),
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },

    {
      Header: "Task Type",
      accessor: "taskType",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      width: 6,
      controlType: "select",
      filterControlType: "select",
      options: {
        keyField: "taskType",
        keyDescription: "taskType",
        values: [],
        url: "/taskType/listAll",
      },

      validation: formControl.string().required("Required").nullable(),
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Assign To",
      accessor: "assignedTo",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      width: 6,
      onChange: onChangeAssign,
      downloadReports: false,
      controlType: "select",
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: 1, description: "Task Group" },
          { id: 2, description: "Individual" },
        ],
      },

      validation: formControl.string().required("Required").nullable(),
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Assignee Group",
      accessor: "assignedGroup",
      displayInList: true,
      allowInForm: assignTo === 1 ? true : false,
      allowFilter: false,
      dataType: "string",
      width: 6,
      controlType: "select",
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
      width: 6,
      options: {
        keyField: "code",
        keyDescription: "code",
        values: [],
        url: "/userGroup/listAll/uniqueGroup",
      },
    },

    {
      Header: "Assignee User",
      accessor: "assignedUser",
      displayInList: true,
      allowInForm: assignTo === 2 ? true : false,
      allowFilter: true,
      dataType: "string",
      width: 6,
      controlType: "select",
      filterControlType: "select",
      options: {
        keyField: "user",
        keyDescription: "user",
        values: [],
        url: "/userRole/listAll/user",
      },

      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Reviewer",
      accessor: "reviewer",
      displayInList: true,
      allowInForm: assignTo === 2 ? true : false,
      allowFilter: true,
      dataType: "string",
      width: 6,
      controlType: "select",
      filterControlType: "select",
      options: {
        keyField: "user",
        keyDescription: "user",
        values: [],
        url: "/userRole/listAll/taskManager",
      },

      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Due date",
      accessor: "expectedCompletionDate",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      isEndTime: true,
      controlType: "dateTime",
      width: 6,

      validation: formControl.string().required("Required").nullable(),
      Cell: ({ value, row }) => <ChangeDateCell value={value} row={row} />,
    },
    {
      Header: "Task Complete Date",
      accessor: "taskCompletedOn",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      controlType: "futureDateTime",
      width: 6,

      validation: formControl.string().required("Required").nullable(),
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Current Status",
      accessor: "currentStats",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      filterControlType: "select",
      dataType: "string",
      controlType: "select",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      options: {
        keyField: "taskStatus",
        keyDescription: "taskStatus",
        values: [],
        url: "/taskStatus/listAll",
      },
    },
    {
      Header: "Task Description",
      accessor: "taskDescription",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 12,

      controlType: "textField",
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "CreatedOn",
      accessor: "createdOn",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      width: 12,

      controlType: "textField",
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "attached file",
      accessor: "filePath",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "fileUpload",
      sendFileInFormData: true,
      fileTypeAccept: ".mp3, .wav, .pdf, .txt, .csv",
      uploadUrl: "task/uploadFile",
      width: 6,
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
